export const constants = {
  get MaxInt(): number {
    return 2147483647;
  }
}
